/**
 * @generated SignedSource<<a40adeabb60d6d1ea1fa4e815b512ccc>>
 * @relayHash b9aeaf48f4c2623bc020eb83707a5e9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce05686bac1c5fe7bb74a6618e7c799eddeb0ed52405ebca7c10f1fc1a018a8b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ce05686bac1c5fe7bb74a6618e7c799eddeb0ed52405ebca7c10f1fc1a018a8b",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
